/* eslint-disable camelcase */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
/* eslint-disable react/prop-types */
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import FilterListIcon from '@material-ui/icons/FilterList'
import SearchIcon from '@material-ui/icons/Search'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { format, isValid } from 'date-fns'
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import React, { useEffect, useState } from 'react'
import { ValidatorForm } from 'react-material-ui-form-validator'
import { useDispatch, useSelector } from 'react-redux'
import { usePermissions } from '../../../hooks/usePermission'

import BadgeGlobal from '../../components/Badge'
import SelectField from '../../components/SelectField'
import NumberFormatCustom from '../../components/NumberFormat'
import { fetchBilling, makeRelatory } from '../BillingActions'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import Icon from '@mdi/react'
import {
  mdiFilterMultiple,
  mdiMagnify,
  mdiMicrosoftExcel,
  mdiNoteEditOutline,
  mdiSearchWeb,
} from '@mdi/js'
import colors from '../../../assets/colors'
import { MenuItem, Typography } from '@material-ui/core'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import { useQueryParams } from '../../../util/utils'
import axios from 'axios'
import config from '../../../config'
import AutoComplete from '../../components/Autocomplete'

export default function Filter({ typeGeneric }) {
  const dispatch = useDispatch()
  const classes = filterStylesComponents()
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate, hasPermission } = usePermissions()

  const statuses = useSelector(state => state.billing.statuses)
  const billingTypes = useSelector(state => state.billing.billingTypes)
  const paymentMethods = useSelector(state => state.billing.paymentMethods)
  const banks = useSelector(state => state.billing.banks)

  const [open, setOpen] = useState(false)
  const [knowWays, setKnowWays] = useState([])

  const [currentForm, setCurrentForm] = useState({
    initial_due_date: null,
    final_due_date: null,
    initial_payment_date: null,
    final_payment_date: null,
    value: '',
    know_ways: [],
  })

  const location = useLocation()
  const history = useHistory()
  const filters = useQueryParams(location.search)

  useEffect(() => {
    axios
      .get(`${config.API_URL}/knowWay`)
      .then(resp => setKnowWays(resp?.data?.data || []))
      .catch(() => setKnowWays([]))
  }, [])

  const toggleModal = () => {
    setOpen(!open)
  }

  const handleExportExcel = () => {
    dispatch(
      makeRelatory({
        ...filters,
        type: typeGeneric,
        billing_type_generic: typeGeneric,
      })
    )
  }

  // Sincroniza o estado do formulário com os filtros da URL. Mantém currentForm
  // como única fonte da verdade dos campos: datas ausentes/vazias viram null
  // (limpar funciona) e datas não alteradas preservam o valor atual da URL.
  const parseDate = value => (value ? new Date(value) : null)

  useEffect(() => {
    setCurrentForm({
      initial_due_date: parseDate(filters?.initial_due_date),
      final_due_date: parseDate(filters?.final_due_date),
      initial_payment_date: parseDate(filters?.initial_payment_date),
      final_payment_date: parseDate(filters?.final_payment_date),
      value: filters?.value || '',
      know_ways: filters?.know_ways ? String(filters.know_ways).split(',') : [],
    })
  }, [location.search])

  const selectedKnowWays = knowWays.filter(knowWay =>
    currentForm.know_ways.includes(String(knowWay.id))
  )

  const onSubmit = (data = filters) => {
    const searchParams = new URLSearchParams(data)
    searchParams.set('page', 1)
    if (open) toggleModal()
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    data.append(
      'initial_due_date',
      isValid(currentForm?.initial_due_date)
        ? currentForm?.initial_due_date?.toISOString()
        : ''
    )
    data.append(
      'final_due_date',
      isValid(currentForm?.final_due_date)
        ? currentForm?.final_due_date?.toISOString()
        : ''
    )
    data.append(
      'initial_payment_date',
      isValid(currentForm?.initial_payment_date)
        ? currentForm?.initial_payment_date?.toISOString()
        : ''
    )
    data.append(
      'final_payment_date',
      isValid(currentForm?.final_payment_date)
        ? currentForm?.final_payment_date?.toISOString()
        : ''
    )
    data.append('value', currentForm?.value || '')
    data.append('know_ways', currentForm?.know_ways?.join(',') || '')
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit({ ...filters, ...values })
  }

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={8}>
        <form style={{ width: '100%' }} onSubmit={handleSubmit}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} sm={4}>
              <TextField
                defaultValue={filters?.person}
                name="person"
                label="Contato Financeiro"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                select
                defaultValue={filters?.status}
                name="status"
                label="Filtre por status"
                fullWidth
              >
                <MenuItem value="0">Selecione...</MenuItem>
                {statuses?.map(status => (
                  <MenuItem value={status?.id} key={status?.id}>
                    {status?.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs>
              <IconButton className={classes.btnAdd} type="submit">
                <Icon path={mdiMagnify} size={1} />
                Pesquisar
              </IconButton>
            </Grid>
          </Grid>
        </form>
      </Grid>

      <Grid item xs={12} sm={4}>
        <Grid container className={classes.areaButtons}>
          <IconButton className={classes.btnMoreFilters} onClick={toggleModal}>
            <Icon path={mdiFilterMultiple} size={1} color={colors.secondary} />
            Filtros
          </IconButton>

          <IconButton className={classes.btnAdd} onClick={handleExportExcel}>
            <Icon path={mdiMicrosoftExcel} size={1} />
            Download
          </IconButton>

          {canCreate('lancamento-contas', permissionUser) && (
            <IconButton
              className={classes.btnAdd}
              component={Link}
              to={`/billing/new${location.search}`}
            >
              <Icon path={mdiNoteEditOutline} size={1} />
              Cadastrar
            </IconButton>
          )}
        </Grid>
      </Grid>

      <BaseFilterModal
        title="FILTRO"
        hiddenHelpButton
        open={open}
        handleOpen={toggleModal}
      >
        <Grid container xs={12} item direction="row" style={{ width: '420px' }}>
          <Grid item xs={12}>
            <Typography
              style={{ fontSize: '16px', fontWeight: 'normal' }}
              color={colors.primary}
            >
              Utilize os campos abaixo para encontrar <br /> uma conta
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <form style={{ width: '100%' }} onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    name="person"
                    label="Contato"
                    fullWidth
                    defaultValue={filters?.person}
                  />
                </Grid>

                {hasPermission('laundry-module', permissionUser) && (
                  <Grid item xs={12}>
                    <TextField
                      name="laundry_name"
                      label="Empresa"
                      fullWidth
                      defaultValue={filters?.laundry_name}
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    name="billing_type"
                    label="Centro de custo"
                    fullWidth
                    defaultValue={filters?.billing_type}
                  >
                    <MenuItem value="">Selecione...</MenuItem>
                    {billingTypes?.map(billingType => (
                      <MenuItem value={billingType?.id} key={billingType?.id}>
                        {billingType?.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    name="status"
                    label="Status"
                    fullWidth
                    defaultValue={filters?.status}
                  >
                    <MenuItem value="">Selecione...</MenuItem>
                    {statuses?.map(status => (
                      <MenuItem value={status?.id} key={status?.id}>
                        {status?.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <AutoComplete
                    options={knowWays}
                    label="Como conheceu"
                    placeholder="Selecione um ou mais"
                    data={selectedKnowWays}
                    limitTags={3}
                    updateFunction={values =>
                      setCurrentForm({
                        ...currentForm,
                        know_ways: values.map(knowWay => String(knowWay.id)),
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    name="payment_method"
                    label="Método de pagamento"
                    fullWidth
                    defaultValue={filters?.payment_method}
                  >
                    <MenuItem value="">Selecione...</MenuItem>
                    {paymentMethods?.map(method => (
                      <MenuItem value={method?.id} key={method?.id}>
                        {method?.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    name="bank"
                    label="Banco"
                    fullWidth
                    defaultValue={filters?.bank}
                  >
                    <MenuItem value="">Selecione...</MenuItem>
                    {banks?.map(bank => (
                      <MenuItem value={bank?.id} key={bank?.id}>
                        {bank?.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item sm={6} xs={12}>
                  <KeyboardDatePicker
                    clearable
                    value={currentForm.initial_due_date}
                    label="Data de Vencimento Inicial"
                    fullWidth
                    clearLabel="Limpar"
                    invalidDateMessage="Data inválida"
                    autoOk
                    onChange={date =>
                      setCurrentForm({ ...currentForm, initial_due_date: date })
                    }
                    format="dd/MM/yyyy"
                  />
                </Grid>

                <Grid item sm={6} xs={12}>
                  <KeyboardDatePicker
                    clearable
                    value={currentForm.final_due_date}
                    label="Data de Vencimento Final"
                    fullWidth
                    clearLabel="Limpar"
                    invalidDateMessage="Data inválida"
                    autoOk
                    onChange={date =>
                      setCurrentForm({ ...currentForm, final_due_date: date })
                    }
                    format="dd/MM/yyyy"
                  />
                </Grid>

                <Grid item sm={6} xs={12}>
                  <KeyboardDatePicker
                    clearable
                    value={currentForm.initial_payment_date}
                    label="Data de Pagamento Inicial"
                    fullWidth
                    clearLabel="Limpar"
                    invalidDateMessage="Data inválida"
                    autoOk
                    onChange={date =>
                      setCurrentForm({
                        ...currentForm,
                        initial_payment_date: date,
                      })
                    }
                    format="dd/MM/yyyy"
                  />
                </Grid>

                <Grid item sm={6} xs={12}>
                  <KeyboardDatePicker
                    clearable
                    value={currentForm.final_payment_date}
                    label="Data de Pagamento Final"
                    fullWidth
                    clearLabel="Limpar"
                    invalidDateMessage="Data inválida"
                    autoOk
                    onChange={date =>
                      setCurrentForm({
                        ...currentForm,
                        final_payment_date: date,
                      })
                    }
                    format="dd/MM/yyyy"
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <TextField
                    label="Filtrar por Valor"
                    helperText="Filtrar contas que possuem esse valor"
                    fullWidth
                    value={currentForm.value || ''}
                    onChange={e =>
                      setCurrentForm({ ...currentForm, value: e.target.value })
                    }
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{ marginTop: '1em' }}
                  container
                  alignItems="center"
                  justifyContent="center"
                >
                  <IconButton type="submit" className={classes.btnSalvar}>
                    <SearchIcon />
                    Pesquisar
                  </IconButton>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </BaseFilterModal>
    </Grid>
  )
}
